/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./Settings.css";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import Image from "react-bootstrap/Image";
import Modal from "react-modal";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/solid";
import {
  Clock,
  MapPin,
  CreditCard,
  Package,
  Truck,
  Building,
  Route,
  X,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import { DHD_PLAN_NAME } from "../../components/DhdCurrentPlanBanner";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import { Link } from "react-router-dom";
import ShipCompanyActivation from "../../components/ShipCompanyActivation";

function Services() {
  const [showSideBar, setShowSideBar] = useState(true);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleOpenModal = (company) => {
    setSelectedCompany(company);
  };

  const handleCloseModal = () => {
    setSelectedCompany(null);
  };

  const store = useSelector((state) => state.StoreReducer);
  const account = useSelector((state) => state.AccountReducer);
  const isDhdUser =
    account?.subscription?.plan === DHD_PLAN_NAME &&
    account?.subscription?.dhdPartnershipActive === true;

  const shippingCompanies = [
    {
      id: "procolis",
      key: "Zrexpress",
      name: "ProColis",
      town: "الجزائر",
      image: "/procolis.png",
      description: t("ShipCollectPage.companiesInfo.procolis.description"),
      link: "/settings/Shipcollect/zrexpress",
      deliveryTime: t("ShipCollectPage.companiesInfo.procolis.deliveryTime"),
      pickupTime: t("ShipCollectPage.companiesInfo.procolis.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.procolis.coverage"),
      cashOnDelivery: t(
        "ShipCollectPage.companiesInfo.procolis.cashOnDelivery",
      ),
      offices: t("ShipCollectPage.companiesInfo.procolis.offices"),
      trackingService: t(
        "ShipCollectPage.companiesInfo.procolis.trackingService",
      ),
      reviews: 120,
      rating: 4.5,
      shippingCompanies: [
        "/zrexpress.png",
        "/colireli.png",
        "/isr.png",
        "/flash.png",
        "/procolis.png",
      ],
    },
    {
      id: "dhd",
      key: "Uecotrack",
      name: "DHD",
      town: "الجزائر",
      image:
        "https://play-lh.googleusercontent.com/-NyxDEFHK6VRmzCptix3FdigtIA-6sVZZM3wK69ZXiboYrt5ZOWDmhdy2dpFdOR49MM",
      description: t("ShipCollectPage.companiesInfo.dhd.description"),
      link: "/settings/Shipcollect/dhd",
      deliveryTime: t("ShipCollectPage.companiesInfo.ecotrack.deliveryTime"),
      pickupTime: t("ShipCollectPage.companiesInfo.ecotrack.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.ecotrack.coverage"),
      cashOnDelivery: t(
        "ShipCollectPage.companiesInfo.ecotrack.cashOnDelivery",
      ),
      offices: t("ShipCollectPage.companiesInfo.ecotrack.offices"),
      trackingService: t(
        "ShipCollectPage.companiesInfo.ecotrack.trackingService",
      ),
      reviews: 0,
      rating: 5,
      shippingCompanies: [
        "https://play-lh.googleusercontent.com/-NyxDEFHK6VRmzCptix3FdigtIA-6sVZZM3wK69ZXiboYrt5ZOWDmhdy2dpFdOR49MM",
      ],
      isDhdOnly: true,
    },
    {
      id: "ecotrack",
      key: "Uecotrack",
      name: t("services.foorCall.companies.ecotrack"),
      town: "الجزائر",
      image: "/ecotrack.png",
      description: t("ShipCollectPage.companiesInfo.ecotrack.description"),
      link: "/settings/Shipcollect/ecotrack",
      deliveryTime: t("ShipCollectPage.companiesInfo.ecotrack.deliveryTime"),
      pickupTime: t("ShipCollectPage.companiesInfo.ecotrack.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.ecotrack.coverage"),
      cashOnDelivery: t(
        "ShipCollectPage.companiesInfo.ecotrack.cashOnDelivery",
      ),
      offices: t("ShipCollectPage.companiesInfo.ecotrack.offices"),
      trackingService: t(
        "ShipCollectPage.companiesInfo.ecotrack.trackingService",
      ),
      reviews: 85,
      rating: 4.2,
      shippingCompanies: [
        "/3_.png",
        "/4_.png",
        "/5_.png",
        "/6_.png",
        "/9_.png",
        "/1-2.png",
      ],
    },
    {
      id: "maystro",
      key: "Maystro",
      name: "Maystro",
      town: "الجزائر",
      image: "/maystro.svg",
      description: t("ShipCollectPage.companiesInfo.maystro.description"),
      link: "/settings/shipcollect/Maystro",
      deliveryTime: t("ShipCollectPage.companiesInfo.maystro.deliveryTime"),
      pickupTime: t("ShipCollectPage.companiesInfo.maystro.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.maystro.coverage"),
      cashOnDelivery: t("ShipCollectPage.companiesInfo.maystro.cashOnDelivery"),
      offices: t("ShipCollectPage.companiesInfo.maystro.offices"),
      trackingService: t(
        "ShipCollectPage.companiesInfo.maystro.trackingService",
      ),
      reviews: 220,
      rating: 4.7,
      shippingCompanies: ["/maystro.svg"],
    },
    {
      id: "yalidine",
      key: "Yalidineid",
      name: t("services.foorCall.companies.yalidine"),
      town: "الجزائر",
      image: "/yalidine.png",
      description: t("ShipCollectPage.companiesInfo.yalidine.description"),
      link: "/settings/shipcollect/yalidine",
      deliveryTime: t("ShipCollectPage.companiesInfo.yalidine.deliveryTime"),
      pickupTime: t("ShipCollectPage.companiesInfo.yalidine.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.yalidine.coverage"),
      cashOnDelivery: t(
        "ShipCollectPage.companiesInfo.yalidine.cashOnDelivery",
      ),
      offices: t("ShipCollectPage.companiesInfo.yalidine.offices"),
      trackingService: t(
        "ShipCollectPage.companiesInfo.yalidine.trackingService",
      ),
      reviews: 310,
      rating: 4.8,
      shippingCompanies: ["/yalidine.png"],
    },
    {
      id: "nordetouest",
      key: "ApitokenNord",
      name: "Nord Et Ouest",
      town: "الجزائر",
      image: "https://app.noest-dz.com/css/customer/images/new_logo_.png",
      description: t("ShipCollectPage.companiesInfo.nordetouest.description"),
      link: "/settings/Shipcollect/nordetouest",
      deliveryTime: t("ShipCollectPage.companiesInfo.nordetouest.deliveryTime"),
      pickupTime: t("ShipCollectPage.companiesInfo.nordetouest.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.nordetouest.coverage"),
      cashOnDelivery: t(
        "ShipCollectPage.companiesInfo.nordetouest.cashOnDelivery",
      ),
      offices: t("ShipCollectPage.companiesInfo.nordetouest.offices"),
      trackingService: t(
        "ShipCollectPage.companiesInfo.nordetouest.trackingService",
      ),
      reviews: 95,
      rating: 4.1,
      shippingCompanies: [
        "https://app.noest-dz.com/css/customer/images/new_logo_.png",
      ],
    },
    {
      id: "guepex",
      key: "UserguidGuepex",
      name: t("services.foorCall.companies.guepex"),
      town: "الجزائر",
      image: "/guepex.png",
      description: t("ShipCollectPage.companiesInfo.guepex.description"),
      link: "/settings/Shipcollect/guepex",
      deliveryTime: t("ShipCollectPage.companiesInfo.guepex.deliveryTime"),
      pickupTime: t("ShipCollectPage.companiesInfo.guepex.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.guepex.coverage"),
      cashOnDelivery: t("ShipCollectPage.companiesInfo.guepex.cashOnDelivery"),
      offices: t("ShipCollectPage.companiesInfo.guepex.offices"),
      trackingService: t(
        "ShipCollectPage.companiesInfo.guepex.trackingService",
      ),
      reviews: 65,
      rating: 4.0,
      shippingCompanies: ["/guepex.png"],
    },
    {
      id: "elogistia",
      key: "apielogistia",
      name: "Elogistia",
      town: "الجزائر",
      image: "/elogistia-logo.png",
      description: t("ShipCollectPage.companiesInfo.elogistia.description"),
      link: "/settings/Shipcollect/elogistia",
      deliveryTime: t("ShipCollectPage.companiesInfo.elogistia.deliveryTime"),
      pickupTime: t("ShipCollectPage.companiesInfo.elogistia.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.elogistia.coverage"),
      cashOnDelivery: t(
        "ShipCollectPage.companiesInfo.elogistia.cashOnDelivery",
      ),
      offices: t("ShipCollectPage.companiesInfo.elogistia.offices"),
      trackingService: t(
        "ShipCollectPage.companiesInfo.elogistia.trackingService",
      ),
      reviews: 150,
      rating: 4.3,
      shippingCompanies: ["/elogistia-logo.png"],
    },
    {
      id: "zimou",
      key: "zimouToken",
      name: "Zimou Express",
      town: "الجزائر",
      image:
        "https://media.licdn.com/dms/image/v2/D4D0BAQFZSW6TIg4J-w/company-logo_200_200/company-logo_200_200/0/1704570721462?e=2147483647&v=beta&t=uuus2Mj66LjoSgi0qr9-BckFBp6MRJPkCgZrXnbIT3Y",
      description: t("ShipCollectPage.companiesInfo.zimou.description"),
      link: "/settings/Shipcollect/zimou",
      deliveryTime: t("ShipCollectPage.companiesInfo.zimou.deliveryTime"),
      pickupTime: t("ShipCollectPage.companiesInfo.zimou.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.zimou.coverage"),
      cashOnDelivery: t("ShipCollectPage.companiesInfo.zimou.cashOnDelivery"),
      offices: t("ShipCollectPage.companiesInfo.zimou.offices"),
      trackingService: t("ShipCollectPage.companiesInfo.zimou.trackingService"),
      reviews: 20,
      rating: 3.8,
      shippingCompanies: [
        "https://media.licdn.com/dms/image/v2/D4D0BAQFZSW6TIg4J-w/company-logo_200_200/company-logo_200_200/0/1704570721462?e=2147483647&v=beta&t=uuus2Mj66LjoSgi0qr9-BckFBp6MRJPkCgZrXnbIT3Y",
      ],
    },
    {
      id: "colivraison",
      key: "coliv_token",
      name: "Colivraison Express",
      town: "الجزائر",
      image: "https://beta.colivraison.express/images/logos/companylogo.png",
      description: t("ShipCollectPage.companiesInfo.colivraison.description"),
      link: "/settings/Shipcollect/colivraison",
      deliveryTime: t("ShipCollectPage.companiesInfo.colivraison.deliveryTime"),
      pickupTime: t("ShipCollectPage.companiesInfo.colivraison.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.colivraison.coverage"),
      cashOnDelivery: t(
        "ShipCollectPage.companiesInfo.colivraison.cashOnDelivery",
      ),
      offices: t("ShipCollectPage.companiesInfo.colivraison.offices"),
      trackingService: t(
        "ShipCollectPage.companiesInfo.colivraison.trackingService",
      ),
      reviews: 20,
      rating: 3.8,
      shippingCompanies: [
        "https://beta.colivraison.express/images/logos/companylogo.png",
      ],
    },
    {
      id: "mdm",
      key: "mdm_apikey",
      name: "MDM Express",
      town: "الجزائر",
      image: "/mdm.png",
      description: t("ShipCollectPage.companiesInfo.mdm.description"),
      link: "/settings/Shipcollect/mdm",
      deliveryTime: t("ShipCollectPage.companiesInfo.mdm.deliveryTime"),
      pickupTime: t("ShipCollectPage.companiesInfo.mdm.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.mdm.coverage"),
      cashOnDelivery: t("ShipCollectPage.companiesInfo.mdm.cashOnDelivery"),
      offices: t("ShipCollectPage.companiesInfo.mdm.offices"),
      trackingService: t("ShipCollectPage.companiesInfo.mdm.trackingService"),
      reviews: 20,
      rating: 3.8,
      shippingCompanies: [
        "https://www.mdm.express/_next/image?url=%2Fmdm.png&w=256&q=75",
      ],
    },
    {
      id: "ameex",
      key: "AmeexId",
      name: "ameex",
      town: "المغرب",
      image: "/Ameex.png",
      description: t("ShipCollectPage.companiesInfo.ameex.description"),
      link: "/settings/Shipcollect/ameex",
      deliveryTime: t("ShipCollectPage.companiesInfo.ameex.deliveryTime"),
      pickupTime: t("ShipCollectPage.companiesInfo.ameex.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.ameex.coverage"),
      cashOnDelivery: t("ShipCollectPage.companiesInfo.ameex.cashOnDelivery"),
      offices: t("ShipCollectPage.companiesInfo.ameex.offices"),
      trackingService: t("ShipCollectPage.companiesInfo.ameex.trackingService"),
      reviews: 10,
      rating: 4.5,
      shippingCompanies: ["/Ameex.png"],
    },
    {
      id: "swiftAbrid",
      key: "swiftAbrid",
      name: "Swift Abrid",
      town: "المغرب",
      image: "/swiftAbrid.png",
      description: t("ShipCollectPage.companiesInfo.swiftAbrid.description"),
      link: "/settings/Shipcollect/ameex",
      deliveryTime: t("ShipCollectPage.companiesInfo.swiftAbrid.deliveryTime"),
      pickupTime: t("ShipCollectPage.companiesInfo.swiftAbrid.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.swiftAbrid.coverage"),
      cashOnDelivery: t(
        "ShipCollectPage.companiesInfo.swiftAbrid.cashOnDelivery",
      ),
      offices: t("ShipCollectPage.companiesInfo.swiftAbrid.offices"),
      trackingService: t(
        "ShipCollectPage.companiesInfo.swiftAbrid.trackingService",
      ),
      reviews: 10,
      rating: 4.5,
      shippingCompanies: ["/swiftAbrid.png"],
    },
    {
      id: "chronodiali",
      key: "chronodiali",
      name: "chrono diali",
      town: "المغرب",
      image: "/chronoDiali.png",
      description: t("ShipCollectPage.companiesInfo.chronodiali.description"),
      link: "/settings/Shipcollect/ameex",
      deliveryTime: t("ShipCollectPage.companiesInfo.chronodiali.deliveryTime"),
      pickupTime: t("ShipCollectPage.companiesInfo.chronodiali.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.chronodiali.coverage"),
      cashOnDelivery: t(
        "ShipCollectPage.companiesInfo.chronodiali.cashOnDelivery",
      ),
      offices: t("ShipCollectPage.companiesInfo.chronodiali.offices"),
      trackingService: t(
        "ShipCollectPage.companiesInfo.chronodiali.trackingService",
      ),
      reviews: 10,
      rating: 4.5,
      shippingCompanies: ["/chronoDiali.png"],
    },
    {
      id: "Cathedis",
      key: "Cathedis",
      name: "Cathedis",
      town: "المغرب",
      image: "https://storeno.b-cdn.net/stores/2-2022/1645790423775.png",
      description: t("ShipCollectPage.companiesInfo.Cathedis.description"),
      link: "/settings/Shipcollect/ameex",
      deliveryTime: t("ShipCollectPage.companiesInfo.Cathedis.deliveryTime"),
      pickupTime: t("ShipCollectPage.companiesInfo.Cathedis.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.Cathedis.coverage"),
      cashOnDelivery: t(
        "ShipCollectPage.companiesInfo.Cathedis.cashOnDelivery",
      ),
      offices: t("ShipCollectPage.companiesInfo.Cathedis.offices"),
      trackingService: t(
        "ShipCollectPage.companiesInfo.Cathedis.trackingService",
      ),
      reviews: 10,
      rating: 4.5,
      shippingCompanies: [
        "https://storeno.b-cdn.net/stores/2-2022/1645790423775.png",
      ],
    },
    {
      id: "Sem",
      key: "Sem",
      name: "Sem",
      town: "المغرب",
      image: "https://storeno.b-cdn.net/stores/7-2022/1658408651520.png",
      description: t("ShipCollectPage.companiesInfo.Sem.description"),
      link: "/settings/Shipcollect/Sem",
      deliveryTime: t("ShipCollectPage.companiesInfo.Sem.deliveryTime"),
      pickupTime: t("ShipCollectPage.companiesInfo.Sem.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.Sem.coverage"),
      cashOnDelivery: t("ShipCollectPage.companiesInfo.Sem.cashOnDelivery"),
      offices: t("ShipCollectPage.companiesInfo.Sem.offices"),
      trackingService: t("ShipCollectPage.companiesInfo.Sem.trackingService"),
      reviews: 10,
      rating: 4.5,
      shippingCompanies: [
        "https://storeno.b-cdn.net/stores/7-2022/1658408651520.png",
      ],
    },
    {
      id: "yalitec",
      key: "YalitecId",
      name: "Yalitec",
      town: "الجزائر",
      image: "/yalitec.png",
      description: t("ShipCollectPage.companiesInfo.yalitec.description"),
      link: "/settings/shipcollect/yalitec",
      deliveryTime: t("ShipCollectPage.companiesInfo.yalitec.deliveryTime"),
      pickupTime: t("ShipCollectPage.companiesInfo.yalitec.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.yalitec.coverage"),
      cashOnDelivery: t("ShipCollectPage.companiesInfo.yalitec.cashOnDelivery"),
      offices: t("ShipCollectPage.companiesInfo.yalitec.offices"),
      trackingService: t(
        "ShipCollectPage.companiesInfo.yalitec.trackingService",
      ),
      reviews: 310,
      rating: 4.8,
      shippingCompanies: ["/yalitec.png"],
    },
    {
      id: "j&tExpressEgypt",
      key: "j&t",
      name: "J&T Express Egypt",
      town: "مصر",
      image: "/J&T_Express.jpg",
      description: t(
        "ShipCollectPage.companiesInfo.j&tExpressEgypt.description",
      ),
      link: "/settings/shipcollect/j&texpressegypt",
      deliveryTime: t(
        "ShipCollectPage.companiesInfo.j&tExpressEgypt.deliveryTime",
      ),
      pickupTime: t("ShipCollectPage.companiesInfo.j&tExpressEgypt.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.j&tExpressEgypt.coverage"),
      cashOnDelivery: t(
        "ShipCollectPage.companiesInfo.j&tExpressEgypt.cashOnDelivery",
      ),
      offices: t("ShipCollectPage.companiesInfo.j&tExpressEgypt.offices"),
      trackingService: t(
        "ShipCollectPage.companiesInfo.j&tExpressEgypt.trackingService",
      ),
      reviews: 310,
      rating: 4.8,
      shippingCompanies: ["/J&T_Express.jpg"],
    },
    {
      id: "bostaEgypt",
      key: "",
      name: "Bosta Egypt",
      town: "مصر",
      image: "/bosta.png",
      description: t("ShipCollectPage.companiesInfo.bostaEgypt.description"),
      link: "/settings/shipcollect/bostaegypt",
      deliveryTime: t("ShipCollectPage.companiesInfo.bostaEgypt.deliveryTime"),
      pickupTime: t("ShipCollectPage.companiesInfo.bostaEgypt.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.bostaEgypt.coverage"),
      cashOnDelivery: t(
        "ShipCollectPage.companiesInfo.bostaEgypt.cashOnDelivery",
      ),
      offices: t("ShipCollectPage.companiesInfo.bostaEgypt.offices"),
      trackingService: t(
        "ShipCollectPage.companiesInfo.bostaEgypt.trackingService",
      ),
      reviews: 209,
      rating: 3.9,
      shippingCompanies: ["/bosta.png"],
    },
    {
      id: "mylerzEgypt",
      key: "mylerzEgypt",
      name: "Mylerz Egypt",
      town: "مصر",
      image: "/mylerz.png",
      description: t("ShipCollectPage.companiesInfo.mylerzEgypt.description"),
      link: "/settings/shipcollect/mylerzegypt",
      deliveryTime: t("ShipCollectPage.companiesInfo.mylerzEgypt.deliveryTime"),
      pickupTime: t("ShipCollectPage.companiesInfo.mylerzEgypt.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.mylerzEgypt.coverage"),
      cashOnDelivery: t(
        "ShipCollectPage.companiesInfo.mylerzEgypt.cashOnDelivery",
      ),
      offices: t("ShipCollectPage.companiesInfo.mylerzEgypt.offices"),
      trackingService: t(
        "ShipCollectPage.companiesInfo.mylerzEgypt.trackingService",
      ),
      reviews: 626,
      rating: 4.3,
      shippingCompanies: ["/mylerz.png"],
    },
    {
      id: "mylerzdz",
      key: "mylerzToken",
      name: "Mylerz Algérie",
      town: "الجزائر",
      image: "/mylerz.png",
      description: t("ShipCollectPage.companiesInfo.mylerzdz.description"),
      link: "/settings/shipcollect/mylerzalgeria",
      deliveryTime: t("ShipCollectPage.companiesInfo.mylerzdz.deliveryTime"),
      pickupTime: t("ShipCollectPage.companiesInfo.mylerzdz.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.mylerzdz.coverage"),
      cashOnDelivery: t(
        "ShipCollectPage.companiesInfo.mylerzdz.cashOnDelivery",
      ),
      offices: t("ShipCollectPage.companiesInfo.mylerzdz.offices"),
      trackingService: t(
        "ShipCollectPage.companiesInfo.mylerzdz.trackingService",
      ),
      reviews: 134,
      rating: 4.5,
      shippingCompanies: ["/mylerz.png"],
    },

    {
      id: "ecomDelivery",
      key: "ecomdelivery_token",
      name: t("services.foorCall.companies.ecomdelivery"),
      town: "الجزائر",
      image: "/ecom_delivery.png",
      description: t("ShipCollectPage.companiesInfo.ecomdelivery.description"),
      link: "/settings/shipcollect/ecomdelivery",
      deliveryTime: t(
        "ShipCollectPage.companiesInfo.ecomdelivery.deliveryTime",
      ),
      pickupTime: t("ShipCollectPage.companiesInfo.ecomdelivery.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.ecomdelivery.coverage"),
      cashOnDelivery: t(
        "ShipCollectPage.companiesInfo.ecomdelivery.cashOnDelivery",
      ),
      offices: t("ShipCollectPage.companiesInfo.ecomdelivery.offices"),
      trackingService: t(
        "ShipCollectPage.companiesInfo.ecomdelivery.trackingService",
      ),
      reviews: 145,
      rating: 4.1,
      shippingCompanies: ["/ecom_delivery.png"],
    },
    {
      id: "flashDelivery",
      key: "flashdelivery_token",
      name: t("ShipCollectPage.companiesInfo.flashdelivery.title"),
      town: "الجزائر",
      image: "/flash.png",
      description: t("ui.flashSummary"),
      link: "/settings/shipcollect/flashdelivery",
      deliveryTime: t(
        "ShipCollectPage.companiesInfo.flashdelivery.deliveryTime",
      ),
      pickupTime: t("ShipCollectPage.companiesInfo.flashdelivery.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.flashdelivery.coverage"),
      cashOnDelivery: t(
        "ShipCollectPage.companiesInfo.flashdelivery.cashOnDelivery",
      ),
      offices: t("ShipCollectPage.companiesInfo.flashdelivery.offices"),
      trackingService: t(
        "ShipCollectPage.companiesInfo.flashdelivery.trackingService",
      ),
      reviews: 145,
      rating: 4.1,
      shippingCompanies: ["/ecom_delivery.png"],
    },
    {
      id: "Zrexpress_v2",
      key: "zrExpressXTenant_V2",
      name: "Zrexpress",
      town: "الجزائر",
      image: "/zrexpress.png",
      description: t("ShipCollectPage.companiesInfo.zrv2.description"),
      link: "/settings/Shipcollect/zrexpress",
      deliveryTime: t("ShipCollectPage.companiesInfo.zrv2.deliveryTime"),
      pickupTime: t("ShipCollectPage.companiesInfo.zrv2.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.zrv2.coverage"),
      cashOnDelivery: t("ShipCollectPage.companiesInfo.zrv2.cashOnDelivery"),
      offices: t("ShipCollectPage.companiesInfo.procolis.offices"),
      trackingService: t("ShipCollectPage.companiesInfo.zrv2.trackingService"),
      reviews: 120,
      rating: 4.5,
      shippingCompanies: ["/zrexpress.png"],
    },
    {
      id: "ecomDeliveryv2",
      key: "ecomdeliveryv2_token",
      name: "Ecom Delivery V2",
      town: "الجزائر",
      image: "/ecom_delivery.png",
      description: t(
        "ShipCollectPage.companiesInfo.ecomdeliveryv2.description",
      ),
      link: "/settings/shipcollect/ecomdeliveryv2",
      deliveryTime: t(
        "ShipCollectPage.companiesInfo.ecomdeliveryv2.deliveryTime",
      ),
      pickupTime: t("ShipCollectPage.companiesInfo.ecomdeliveryv2.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.ecomdeliveryv2.coverage"),
      cashOnDelivery: t(
        "ShipCollectPage.companiesInfo.ecomdeliveryv2.cashOnDelivery",
      ),
      offices: t("ShipCollectPage.companiesInfo.ecomdeliveryv2.offices"),
      trackingService: t(
        "ShipCollectPage.companiesInfo.ecomdeliveryv2.trackingService",
      ),
      reviews: 145,
      rating: 4.1,
      shippingCompanies: ["/ecom_delivery.png"],
    },
    {
      id: "turboEgypt",
      key: "YalitecId",
      name: "Turbo Egypt",
      town: "مصر",
      image: "/turbo.png",
      description: t("ShipCollectPage.companiesInfo.turboEgypt.description"),
      link: "/settings/shipcollect/turboegypt",
      deliveryTime: t("ShipCollectPage.companiesInfo.turboEgypt.deliveryTime"),
      pickupTime: t("ShipCollectPage.companiesInfo.turboEgypt.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.turboEgypt.coverage"),
      cashOnDelivery: t(
        "ShipCollectPage.companiesInfo.turboEgypt.cashOnDelivery",
      ),
      offices: t("ShipCollectPage.companiesInfo.turboEgypt.offices"),
      trackingService: t(
        "ShipCollectPage.companiesInfo.turboEgypt.trackingService",
      ),
      reviews: null,
      rating: null,
      shippingCompanies: ["/turbo.png"],
    },
    {
      id: "optimusEgypt",
      key: "YalitecId",
      name: "Optimus Egypt",
      town: "مصر",
      image: "/Optimus.png",
      description: t("ShipCollectPage.companiesInfo.optimusEgypt.description"),
      link: "/settings/shipcollect/optimusegypt",
      deliveryTime: t(
        "ShipCollectPage.companiesInfo.optimusEgypt.deliveryTime",
      ),
      pickupTime: t("ShipCollectPage.companiesInfo.optimusEgypt.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.optimusEgypt.coverage"),
      cashOnDelivery: t(
        "ShipCollectPage.companiesInfo.optimusEgypt.cashOnDelivery",
      ),
      offices: t("ShipCollectPage.companiesInfo.optimusEgypt.offices"),
      trackingService: t(
        "ShipCollectPage.companiesInfo.optimusEgypt.trackingService",
      ),
      reviews: null,
      rating: null,
      shippingCompanies: ["/Optimus.png"],
    },
    {
      id: "phoenixLogisticsEgypt",
      key: "YalitecId",
      name: "Phoenix Logistics Egypt",
      town: "مصر",
      image: "/Phoenix-express.jpg",
      description: t(
        "ShipCollectPage.companiesInfo.phoenixLogisticsEgypt.description",
      ),
      link: "/settings/shipcollect/phoenixlogisticsegypt",
      deliveryTime: t(
        "ShipCollectPage.companiesInfo.phoenixLogisticsEgypt.deliveryTime",
      ),
      pickupTime: t(
        "ShipCollectPage.companiesInfo.phoenixLogisticsEgypt.pickupTime",
      ),
      coverage: t(
        "ShipCollectPage.companiesInfo.phoenixLogisticsEgypt.coverage",
      ),
      cashOnDelivery: t(
        "ShipCollectPage.companiesInfo.phoenixLogisticsEgypt.cashOnDelivery",
      ),
      offices: t("ShipCollectPage.companiesInfo.phoenixLogisticsEgypt.offices"),
      trackingService: t(
        "ShipCollectPage.companiesInfo.phoenixLogisticsEgypt.trackingService",
      ),
      reviews: null,
      rating: null,
      shippingCompanies: ["/Phoenix-express.jpg"],
    },
    {
      id: "qpExpressEgypt",
      key: "YalitecId",
      name: "QP Express Egypt",
      town: "مصر",
      image: "/qp-experss.png",
      description: t(
        "ShipCollectPage.companiesInfo.qpExpressEgypt.description",
      ),
      link: "/settings/shipcollect/qpexpressegypt",
      deliveryTime: t(
        "ShipCollectPage.companiesInfo.qpExpressEgypt.deliveryTime",
      ),
      pickupTime: t("ShipCollectPage.companiesInfo.qpExpressEgypt.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.qpExpressEgypt.coverage"),
      cashOnDelivery: t(
        "ShipCollectPage.companiesInfo.qpExpressEgypt.cashOnDelivery",
      ),
      offices: t("ShipCollectPage.companiesInfo.qpExpressEgypt.offices"),
      trackingService: t(
        "ShipCollectPage.companiesInfo.qpExpressEgypt.trackingService",
      ),
      reviews: null,
      rating: null,
      shippingCompanies: ["/qp-experss.png"],
    },
    {
      id: "arriveEgypt",
      key: "YalitecId",
      name: "Arrive Shipping Egypt",
      town: "مصر",
      image: "/arrive.png",
      description: t("ShipCollectPage.companiesInfo.arriveEgypt.description"),
      link: "/settings/shipcollect/arriveegypt",
      deliveryTime: t("ShipCollectPage.companiesInfo.arriveEgypt.deliveryTime"),
      pickupTime: t("ShipCollectPage.companiesInfo.arriveEgypt.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.arriveEgypt.coverage"),
      cashOnDelivery: t(
        "ShipCollectPage.companiesInfo.arriveEgypt.cashOnDelivery",
      ),
      offices: t("ShipCollectPage.companiesInfo.arriveEgypt.offices"),
      trackingService: t(
        "ShipCollectPage.companiesInfo.arriveEgypt.trackingService",
      ),
      reviews: null,
      rating: null,
      shippingCompanies: ["/arrive.png"],
    },
    {
      id: "osen",
      key: "OsenToken",
      name: t("services.foorCall.companies.osen"),
      town: "الجزائر",
      image: "/osen.png",
      description: t("ShipCollectPage.companiesInfo.osen.description"),
      link: "/settings/shipcollect/osen",
      deliveryTime: t("ShipCollectPage.companiesInfo.osen.deliveryTime"),
      pickupTime: t("ShipCollectPage.companiesInfo.osen.pickupTime"),
      coverage: t("ShipCollectPage.companiesInfo.osen.coverage"),
      cashOnDelivery: t("ShipCollectPage.companiesInfo.osen.cashOnDelivery"),
      offices: t("ShipCollectPage.companiesInfo.osen.offices"),
      trackingService: t("ShipCollectPage.companiesInfo.osen.trackingService"),
      reviews: 0,
      rating: 0,
      shippingCompanies: ["/osen.png"],
    },
  ];

  const filteredCompanies = shippingCompanies.filter((company) => {
    if (!isDhdUser && company.id === "dhd") return false;
    return true;
  });

  const [isOpen, setIsOpen] = useState({});

  const toggleDropdown = (id) => {
    setIsOpen((prev) => ({ ...prev, [id]: !prev[id] }));
  };
  const [activeFilter, setActiveFilter] = useState("detailsCompany");

  const companyFormConfig = {
    procolis: ["Token", "Cle"],
    ecotrack: ["URL society delivery", "Token"],
    maystro: ["User Maystro"],
    yalidine: [
      "Id Yalidine",
      "Token Yalidine",
      "ولاية التي ترسل منها بالفرنسية",
    ],
    nordetouest: ["User guid", "Api token"],
    guepex: ["API ID", "API token"],
    elogistia: ["ApiKey"],
    zimou: ["zimouToken"],
    colivraison: ["coliv_token", "coliv_pubKey"],
  };

  const [companyForms, setCompanyForms] = useState({});

  useEffect(() => {
    if (selectedCompany) {
      setCompanyForms((prevForms) => ({
        ...prevForms,
        [selectedCompany.id]: companyFormConfig[selectedCompany.id]?.reduce(
          (acc, field) => ({ ...acc, [field]: "" }),
          {},
        ),
      }));
    }
  }, [selectedCompany]);

  const handleChange = (companyId, field, value) => {
    setCompanyForms((prevForms) => ({
      ...prevForms,
      [companyId]: {
        ...prevForms[companyId],
        [field]: value,
      },
    }));
  };

  const handleSubmit = (companyId) => {
    console.log("Submitting for:", companyId, companyForms[companyId]);
  };

  return (
    <div
      className="container-fluid bg-purple-50 dark:!bg-[#141414] min-h-screen"
      dir={isRTL ? "rtl" : "ltr"}
    >
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 dark:!bg-[#141414]"
          style={{
            flex: 1,
            backgroundColor: "#fbf8fc",
          }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          {/* Page Header */}
          <div className="bg-white rounded-xl shadow-sm p-4 m-3 border border-[#fbf4ff] dark:!bg-[#181819] dark:!border-[#3c3a3d]">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-bold text-[#9e68ba] mb-1">
                  {t("ShipCollectPage.section.title")}
                </h2>
                <p className="text-gray-600 mb-0 dark:!text-gray-300">
                  {t("ShipCollectPage.section.description")}
                </p>
              </div>
            </div>
          </div>

          {/* Shipping Companies Grid */}
          <div className="p-3">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {filteredCompanies.map((company) => {
                const isDhdCard = company.id === "dhd";
                const isDisabledByDhd = isDhdUser && !isDhdCard;

                return (
                  <div
                    key={company.id}
                    className={`bg-white dark:!bg-[#181819] rounded-xl shadow-sm border border-[#fbf4ff] dark:!border-[#3c3a3d] overflow-hidden transition-all duration-200 relative ${
                      isDisabledByDhd
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:shadow-md"
                    }`}
                    title={
                      isDisabledByDhd
                        ? t("ShipCollectPage.dhd_not_supported")
                        : undefined
                    }
                  >
                    {isDisabledByDhd && (
                      <div
                        className="absolute inset-0 z-10 cursor-not-allowed"
                        title={t("ShipCollectPage.dhd_not_supported")}
                      />
                    )}
                    {/* Company Header */}
                    <div className="p-4 h-[150px]">
                      <div className="flex items-start justify-between">
                        <div className="flex items-start gap-3">
                          <div className="rounded-xl border border-[#fbf4ff] dark:!border-[#3c3a3d] p-2 w-16 h-16 flex items-center justify-center bg-white dark:!bg-[#2a2a2a] shrink-0">
                            <Image
                              src={company.image}
                              alt={company.name}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                              }}
                            />
                          </div>

                          <div>
                            <h3
                              className="font-bold text-xl text-[#9e68ba] mb-1 cursor-pointer"
                              onClick={() => {
                                if (isDisabledByDhd) return;
                                handleOpenModal(company);
                              }}
                            >
                              {company.name}
                            </h3>

                            <div className="flex items-center text-sm text-gray-500 mb-2">
                              <span className="text-yellow-400 ml-1">⭐</span>
                              <span className="font-semibold text-gray-700 dark:!text-gray-300 mx-1">
                                {company.rating}
                              </span>
                              <span>
                                ({company.reviews}{" "}
                                {t(
                                  "ShipCollectPage.section.company.rating_label",
                                )}
                                )
                              </span>
                            </div>

                            {store[company.key] !== null &&
                            store[company.key] !== "" &&
                            store[company.key] !== false &&
                            store[company.key] !== undefined ? (
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 dark:!bg-green-900 text-green-800 dark:!text-green-300">
                                <CheckCircleIcon className="w-3.5 h-3.5 ml-1" />
                                {t("ShipCollectPage.section.company.connected")}
                              </span>
                            ) : (
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 dark:!bg-red-900 text-red-800 dark:!text-red-300">
                                <XCircleIcon className="w-3.5 h-3.5 ml-1" />
                                {t(
                                  "ShipCollectPage.section.company.not_connected",
                                )}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <p className="text-gray-600 dark:!text-gray-400 text-sm mt-3 line-clamp-2">
                        {company.description}
                      </p>
                    </div>

                    {/* Company Footer */}
                    <div className="border-t border-[#fbf4ff] dark:!border-[#3c3a3d] p-4 bg-gradient-to-r from-purple-50 to-white dark:!from-[#2a2a2a] dark:!to-[#181819]">
                      <button
                        onClick={() => {
                          if (isDisabledByDhd) return;
                          handleOpenModal(company);
                        }}
                        disabled={isDisabledByDhd}
                        className={`w-full text-base py-2 px-4 rounded-lg font-medium flex items-center justify-center transition-colors ${
                          isDisabledByDhd
                            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                            : "bg-[#9b59bf] hover:bg-[#814a9f] text-white"
                        }`}
                      >
                        {t("ShipCollectPage.section.company.button_label")}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Modal */}
          {selectedCompany && (
            <Modal
              isOpen={!!selectedCompany}
              onRequestClose={handleCloseModal}
              className="fixed inset-0 z-[9999999] flex items-center justify-center"
              overlayClassName="fixed inset-0 bg-black bg-opacity-50 z-40"
              contentLabel={`${selectedCompany.name} Details`}
              ariaHideApp={false}
              style={{
                overlay: {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 99999,
                },
                content: {
                  position: "relative",
                  top: "auto",
                  left: "auto",
                  right: "auto",
                  bottom: "auto",
                  border: "none",
                  background: "transparent",
                  overflow: "visible",
                  borderRadius: "0",
                  outline: "none",
                  padding: "0",
                  maxWidth: "600px",
                  width: "90%",
                  height: "auto",
                  maxHeight: "90vh",
                  "@media (max-width: 768px)": {
                    maxHeight: "80vh",
                    height: "80vh",
                    width: "95%",
                  },
                  margin: "0 auto",
                },
              }}
            >
              <div
                className="bg-white dark:!bg-[#181819] rounded-xl shadow-xl overflow-hidden w-full "
                dir={t("services.direction")}
              >
                {/* Tab Buttons */}
                <div className="flex border-b border-[#fbf4ff] dark:!border-[#3c3a3d]">
                  <button
                    className={`flex-1 py-3 px-4 text-center font-medium transition-colors ${
                      activeFilter === "detailsCompany"
                        ? "bg-purple-50 dark:bg-[#522868] dark:text-gray-300 text-[#9e68ba] border-b-2 border-[#9b59bf]"
                        : "text-gray-600 hover:bg-purple-50 dark:text-gray-300 hover:dark:bg-[#6e358c]"
                    }`}
                    onClick={() => setActiveFilter("detailsCompany")}
                  >
                    {t("ShipCollectPage.modal.tabs.details")}
                  </button>
                  <button
                    className={`flex-1 py-3 px-4 text-center font-medium transition-colors ${
                      activeFilter === "activeCompany"
                        ? "bg-purple-50 dark:bg-[#522868] dark:text-gray-300 text-[#9e68ba] border-b-2 border-[#9b59bf]"
                        : "text-gray-600 hover:bg-purple-50 dark:text-gray-300 hover:dark:bg-[#6e358c]"
                    }`}
                    onClick={() => setActiveFilter("activeCompany")}
                  >
                    {t("ShipCollectPage.modal.tabs.activate")}
                  </button>
                </div>

                {/* Company Details */}
                {activeFilter === "detailsCompany" && selectedCompany && (
                  <div className="max-h-[80vh] overflow-y-auto">
                    <div className="p-6">
                      {/* Company Header */}
                      <div className="flex items-center justify-between mb-4">
                        <div>
                          <h3 className="text-xl font-bold text-[#9e68ba]">
                            {selectedCompany.name}
                          </h3>
                          <p className="text-gray-600 dark:!text-gray-300">
                            {selectedCompany.description}
                          </p>
                        </div>
                        <div className="w-20 h-20 rounded-xl border border-[#fbf4ff] p-2 flex items-center justify-center bg-white">
                          <Image
                            src={selectedCompany.image}
                            alt={selectedCompany.name}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      </div>

                      {/* Company Info Grid */}
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
                        <div className="bg-[#fcf6ff] p-4 rounded-lg border border-[#fbf4ff] dark:!bg-[#181819] dark:!border-[#3c3a3d]">
                          <div className="flex items-center gap-2 mb-2">
                            <Clock size={18} className="text-[#9e68ba]" />
                            <h4 className="font-medium text-base text-[#9e68ba]">
                              {t("ShipCollectPage.modal.labels.deliveryTime")}
                            </h4>
                          </div>
                          <p className="text-gray-700 mr-6 dark:!text-gray-300">
                            {selectedCompany.deliveryTime}
                          </p>
                        </div>

                        <div className="bg-[#fcf6ff] p-4 rounded-lg border border-[#fbf4ff] dark:!bg-[#181819] dark:!border-[#3c3a3d]">
                          <div className="flex items-center gap-2 mb-2">
                            <Package size={18} className="text-[#9e68ba]" />
                            <h4 className="font-medium text-base text-[#9e68ba]">
                              {t("ShipCollectPage.modal.labels.pickupTime")}
                            </h4>
                          </div>
                          <p className="text-gray-700 mr-6 dark:!text-gray-400">
                            {selectedCompany.pickupTime}
                          </p>
                        </div>

                        <div className="bg-[#fcf6ff] p-4 rounded-lg border border-[#fbf4ff] dark:!bg-[#181819] dark:!border-[#3c3a3d]">
                          <div className="flex items-center gap-2 mb-2">
                            <MapPin size={18} className="text-[#9e68ba]" />
                            <h4 className="font-medium text-base text-[#9e68ba]">
                              {t("ShipCollectPage.modal.labels.coverage")}
                            </h4>
                          </div>
                          <p className="text-gray-700 mr-6 dark:!text-gray-400">
                            {selectedCompany.coverage}
                          </p>
                        </div>

                        <div className="bg-[#fcf6ff] p-4 rounded-lg border border-[#fbf4ff] dark:!bg-[#181819] dark:!border-[#3c3a3d]">
                          <div className="flex items-center gap-2 mb-2">
                            <CreditCard size={18} className="text-[#9e68ba]" />
                            <h4 className="font-medium text-base text-[#9e68ba]">
                              {t("ShipCollectPage.modal.labels.cod")}
                            </h4>
                          </div>
                          <p className="text-gray-700 mr-6 dark:!text-gray-400">
                            {selectedCompany.cashOnDelivery}
                          </p>
                        </div>

                        <div className="bg-[#fcf6ff] p-4 rounded-lg border border-[#fbf4ff] dark:!bg-[#181819] dark:!border-[#3c3a3d]">
                          <div className="flex items-center gap-2 mb-2">
                            <Building size={18} className="text-[#9e68ba]" />
                            <h4 className="font-medium text-base text-[#9e68ba]">
                              {t("ShipCollectPage.modal.labels.offices")}
                            </h4>
                          </div>
                          <p className="text-gray-700 mr-6 dark:!text-gray-400">
                            {selectedCompany.offices}
                          </p>
                        </div>

                        <div className="bg-[#fcf6ff] p-4 rounded-lg border border-[#fbf4ff] dark:!bg-[#181819] dark:!border-[#3c3a3d]">
                          <div className="flex items-center gap-2 mb-2">
                            <Route size={18} className="text-[#9e68ba]" />
                            <h4 className="font-medium text-base text-[#9e68ba]">
                              {t("ShipCollectPage.modal.labels.tracking")}
                            </h4>
                          </div>
                          <p className="text-gray-700 mr-6 dark:!text-gray-400">
                            {selectedCompany.trackingService}
                          </p>
                        </div>
                      </div>

                      {/* Shipping Partners */}
                      {selectedCompany.shippingCompanies &&
                        selectedCompany.shippingCompanies.length > 0 && (
                          <div className="mt-6">
                            <div className="flex items-center gap-2 mb-3">
                              <Truck size={18} className="text-[#9e68ba]" />
                              <h4 className="font-medium text-base text-[#9e68ba]">
                                {t(
                                  "ShipCollectPage.modal.labels.shippingPartners",
                                )}
                              </h4>
                            </div>

                            <div className="bg-[#fcf6ff] p-4 rounded-lg border border-[#fbf4ff] dark:!bg-[#181819] dark:!border-[#3c3a3d]">
                              <div className="flex flex-wrap gap-3 justify-start items-center">
                                {selectedCompany.shippingCompanies.map(
                                  (logo, index) => (
                                    <div
                                      key={index}
                                      className="w-16 h-16 bg-white dark:!bg-[#181819] dark:!border-[#3c3a3d] rounded-lg p-2 border border-[#fbf4ff] flex items-center justify-center"
                                    >
                                      <Image
                                        src={logo}
                                        alt={t("ui.shippingPartner")}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "contain",
                                        }}
                                      />
                                    </div>
                                  ),
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                )}

                {/* Company Activation */}
                {activeFilter === "activeCompany" && selectedCompany && (
                  <div className="p-6">
                    <ShipCompanyActivation company={selectedCompany} />
                  </div>
                )}

                {/* Modal Footer */}
                <div className="border-t border-[#fbf4ff] dark:!border-[#3c3a3d] p-4 bg-gray-50 dark:!bg-[#181919] flex justify-between">
                  <button
                    className="text-gray-600 dark:!text-gray-300 hover:text-gray-900 dark:hover:text-white bg-white dark:!bg-[#181919] border border-gray-300 dark:!border-[#3c3a3d] hover:bg-gray-50 dark:hover:bg-[#222222] font-medium py-2 px-4 rounded-lg transition-colors duration-200 flex items-center gap-2"
                    onClick={handleCloseModal}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                    {t("ShipCollectPage.modal.actions.close")}
                  </button>
                </div>
              </div>
            </Modal>
          )}

          <Footer />
        </div>
      </div>
    </div>
  );
}

export default Services;
